// import node package 'pdfjs-dist'
import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf";
import workerSrc from "pdfjs-dist/build/pdf.worker.min.js";
pdfjsLib.GlobalWorkerOptions.workerSrc = workerSrc;

document.addEventListener('turbolinks:load', () => {
    const sgScreen = document.getElementById('sgScreen')
    const selfGuidedStationFullScreenPreview = document.getElementById('selfGuidedStationFullScreenPreview')
    const closeLink = document.getElementById('self_guided_close_fullscreen')

    const selfGuidedStationPreviewPortraitVideo = document.getElementById('selfGuidedStationPreviewPortraitVideo')
    const selfGuidedStationPreviewLandscapeVideo = document.getElementById('selfGuidedStationPreviewLandscapeVideo')
    // set video to current media independent of orientation
    const video = selfGuidedStationPreviewPortraitVideo || selfGuidedStationPreviewLandscapeVideo

    const guestStationPreviewLandscapeImage = document.getElementById('guestStationPreviewLandscapeImage')
    const pdfContainer = document.getElementById('pdfContainer')

    // pdf load logic
    let loadQueue = Promise.resolve(); //queue pdf loads on resize
    let loadingTask = null; // To track the current PDF loading task
    let latestTaskId = 0; // save current PDF load task id

    //landscape resize
    if (sgScreen !== null && selfGuidedStationFullScreenPreview !== null &&
        (selfGuidedStationPreviewLandscapeVideo !== null || guestStationPreviewLandscapeImage !== null || pdfContainer != null)) {
        resize()
    }

    // Video ended
    if (sgScreen !== null && video !== null){
        video.addEventListener('ended', redirectWithoutAutoplay)
    }

    function resize() {
        let resizeObserver = new ResizeObserver(() => {
            const currentSgScreenWidth = sgScreen.getBoundingClientRect().width
            const currentSgScreenHeight = sgScreen.getBoundingClientRect().height
            let usedScreenHeight = currentSgScreenHeight

            // resize rotate video
            if (selfGuidedStationPreviewLandscapeVideo !== null) {
                selfGuidedStationPreviewLandscapeVideo.style.height = `${currentSgScreenHeight}px`
                selfGuidedStationPreviewLandscapeVideo.style.minHeight = `${currentSgScreenHeight}px`
            }

            // resize rotate image (only for landscape)
            if (guestStationPreviewLandscapeImage != null) {
                // Get original size of image
                const imageWidth = guestStationPreviewLandscapeImage.naturalWidth
                const imageHeight = guestStationPreviewLandscapeImage.naturalHeight

                const ratio = Math.min(usedScreenHeight / imageHeight, currentSgScreenWidth / imageWidth);
                const usedImageWidth = imageWidth*ratio
                const usedImageHeight = imageHeight*ratio
                // Set min and max instead of only width, cause sometimes it ignores the width (maybe because of rotated container)
                guestStationPreviewLandscapeImage.style.maxWidth = `${usedImageWidth}px`
                guestStationPreviewLandscapeImage.style.maxHeight = `${usedImageHeight}px`
                guestStationPreviewLandscapeImage.style.minWidth = `${usedImageWidth}px`
                guestStationPreviewLandscapeImage.style.minHeight = `${usedImageHeight}px`
            }

            // resize pdf
            if (pdfContainer !== null) {
                // Cancel the currently running PDF load (if any)
                if (loadingTask) {
                    loadingTask.destroy();
                    loadingTask = null;
                }

                // Generate a new unique ID for the latest resize event
                const currentTaskId = ++latestTaskId;

                // Add a new PDF load task to the queue, ensuring sequential execution.
                // Any outdated tasks (from previous resizes) will be skipped, and only the latest one will run.
                loadQueue = loadQueue.then(() => {
                    //sequential part -one resize after the other

                    // Ignore outdated tasks
                    if (currentTaskId !== latestTaskId) {
                        return; // Ignore outdated tasks
                    }
                    // executes the latest load
                    return loadPdf()
                });
            }

        })
        resizeObserver.observe(sgScreen);
    }


    /**
     * Loads the PDF from the URL specified in the `data-pdf-url` attribute of `pdfPreviewContainer`.
     *
     * This function:
     * - Retrieves the PDF URL dynamically.
     * - Starts a new PDF loading task using `pdfjsLib.getDocument()`.
     * - Returns a promise that resolves when the PDF is fully loaded.
     * - Ensures only the latest PDF is loaded, as older tasks are ignored in the main execution flow.
     */
    function loadPdf() {

        // Clear previous PDF pages
        pdfContainer.innerHTML = "";

        // Start loading the PDF document asynchronously using pdf.js
        const url = pdfContainer.dataset.pdfUrl
        loadingTask = pdfjsLib.getDocument(url)

        // Return a promise that resolves when the PDF is fully loaded
        return loadingTask.promise
            .then(pdf => {
                // loop over pages of pdf
                for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
                    pdf.getPage(pageNum).then(page => {

                        // get pdf page dimensions
                        const originalViewport = page.getViewport({ scale: 1 });
                        const originalWidth = originalViewport.width;
                        const originalHeight = originalViewport.height;

                        // Get pdfContainer dimensions (already fixed)
                        const pdfContainer = document.getElementById('pdfContainer')

                        // handle running promise after navigating away
                        if (pdfContainer == null) {
                            return
                        }

                        const containerWidth  = pdfContainer.getBoundingClientRect().width;
                        const containerHeight  = pdfContainer.getBoundingClientRect().height;

                        // Calculate scale to fit while maintaining aspect ratio
                        const scaleX = containerWidth / originalWidth;
                        const scaleY = containerHeight / originalHeight;
                        const scale =  Math.min(scaleX, scaleY) ; // Use the smaller scale to avoid distortion

                        // Create a newCanvas inside pdfContainer
                        const newCanvas = document.createElement("canvas");
                        newCanvas.classList.add("pdfCanvasPage")
                        const context = newCanvas.getContext("2d");

                        // Compute the new viewport with correct scaling
                        const scaledViewport = page.getViewport({ scale });

                        // Set the newCanvas dimensions based on scaled PDF size
                        newCanvas.width = scaledViewport.width;
                        newCanvas.height = scaledViewport.height;

                        // set padding to center pages
                        const marginToCenter = (containerHeight - scaledViewport.height)/2
                        newCanvas.style.paddingTop = `${marginToCenter}px`
                        newCanvas.style.paddingBottom = `${marginToCenter}px`

                        // Append newCanvas to the div container
                        pdfContainer.appendChild(newCanvas);

                        // Render PDF on newCanvas
                        const renderContext = {
                            canvasContext: context,
                            viewport: scaledViewport
                        };

                        page.render(renderContext)
                    })
                }
            })
            .catch(() => {
                // handle destroy of task without  exception
            })
            .finally(() => {
                loadingTask = null;
            })
    }

    // Close fullscreen view and redirects back
    // Redirect to station for multi stations
    // Redirect to station_list for single stations
    function redirectWithoutAutoplay(){
        if (closeLink){
            if(closeLink.href.includes("self_guided_station_select_preview")){
                // leave station, correct link
                window.open(closeLink.href, "_self")
            } else {
                // return to station, change link for no autoplay
                let hrefArray = closeLink.href.split('/')
                hrefArray[hrefArray.length -1] = '0'
                let href = hrefArray.join('/')
                window.open(href, "_self")
            }
        }
    }
})